<div class="p-6 card-style-full">
  <div class="flex justify-between items-center mb-4">
    <h2 class="text-gray-700 font-bold">Editar veículo — {{ data.veiculo.placa }}</h2>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div [formGroup]="form" class="flex flex-col gap-3">
    @if (modeloNaoIdentificado) {
      <p class="text-sm text-amber-600">
        Não conseguimos identificar automaticamente o modelo atual ("{{ data.veiculo.modelo }}"). Selecione novamente.
      </p>
    }
    <div class="flex gap-4">
      <mat-form-field class="input-tg" style="width:160px" appearance="outline">
        <mat-label>Marca *</mat-label>
        <mat-select [formControl]="marcaControl">
          @for (item of vehicleBrands; track item.id) {
            <mat-option [value]="item.id">{{ item.marca }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg flex-1" appearance="outline">
        <mat-label>Modelo *</mat-label>
        <mat-select formControlName="veiculoModeloId" [disabled]="!marcaControl.value">
          @for (item of filteredVehicleModels; track item.id) {
            <mat-option [value]="item.id">{{ item.modelo }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg flex-1" appearance="outline">
        <mat-label>Tipo de Veículo *</mat-label>
        <mat-select formControlName="tipoVeiculoId">
          @for (item of vehicleTypes; track item.id) {
            <mat-option [value]="item.id">{{ item.descricao }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="input-tg" style="width:140px" appearance="outline">
        <mat-label>Cor *</mat-label>
        <input matInput formControlName="cor" />
      </mat-form-field>
      <mat-form-field class="input-tg" style="width:110px" appearance="outline">
        <mat-label>Ano</mat-label>
        <input matInput type="number" formControlName="ano" />
      </mat-form-field>
    </div>
    <div class="flex gap-4">
      <mat-form-field class="input-tg flex-1" appearance="outline">
        <mat-label>CRLV *</mat-label>
        <input matInput formControlName="crlv" />
      </mat-form-field>
      <mat-form-field class="input-tg flex-1" appearance="outline">
        <mat-label>Seguro</mat-label>
        <input matInput formControlName="seguro" />
      </mat-form-field>
      <mat-form-field class="input-tg" style="width:160px" appearance="outline">
        <mat-label>Validade seguro</mat-label>
        <input matInput [matDatepicker]="seguroPicker" (focus)="seguroPicker.open()" formControlName="seguroValidade" />
        <mat-datepicker-toggle matIconSuffix [for]="seguroPicker"></mat-datepicker-toggle>
        <mat-datepicker #seguroPicker></mat-datepicker>
      </mat-form-field>
    </div>

    <div class="flex justify-end mt-2">
      <button
        mat-flat-button class="btn-tg"
        [disabled]="form.invalid || saving"
        (click)="save()"
      >
        @if (saving) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Salvar
        }
      </button>
    </div>

    <h4 class="mt-2">Documentos</h4>
    <supplier-portal-documents [escopo]="'veiculo'" [ownerId]="data.veiculo.id" />
  </div>
</div>
